import { FC } from 'react';
import { Link } from 'react-router-dom';

import { ButtonV2 } from '../../../component-lib/atoms/button-v2/ButtonV2';

interface Props {
  title?: string;
}
export const BackButton: FC<Props> = ({ title = 'Back to sweets' }) => (
  <Link to="/toy-shop/sweet">
    <ButtonV2>{title}</ButtonV2>
  </Link>
);
